import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../../services/api/auth/auth.service";
import { inject } from "@angular/core";
import { catchError, map, Observable, of, switchMap } from "rxjs";
import { PreferredLanguageService } from "../../services/state/preferred-language/preferred-language.service";

export const authGuard: CanActivateFn = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const preferredLanguage = inject(PreferredLanguageService);
  const router = inject(Router);
  return authService.isAuth$().pipe(
    switchMap((isAuth: boolean) => {
      if (!isAuth) {
        router.navigate(["/login"]);
        return of(false);
      }

      return preferredLanguage.reconcile().pipe(
        map(() => true),
        catchError(() => of(true))
      );
    })
  );
};
